import { formatMoney } from '@shopify/theme-currency'
import { isFrenchLocale } from './storeLocales'

// Currency Formatting Docs: https://help.shopify.com/en/manual/payments/currency-formatting
// Money Filter Docs: https://shopify.dev/api/liquid/filters/money-filters

export function formatCurrencyByLocale({
    amount,
    format,
    isSuperscriptTag = false,
    hasSpacing = false
  }) {
    let currencyFormat = format || `{{ amount }}`
    const htmlTag = isSuperscriptTag ?  `sup` : `span`
    const classnames = `currency-symbol ${hasSpacing ? `has-spacing`: ``}`
    if (isFrenchLocale()) {
      let currencyFormat = `{{ amount_with_comma_separator }}`
      let formattedPrice = `${formatMoney(amount, currencyFormat)}<${htmlTag} class="transifex-ignore fr ${classnames}">$</${htmlTag}>`
      formattedPrice = formattedPrice.replace(`.`, ` `)
      return formattedPrice
    }

    const formattedPrice = `<${htmlTag} class="en ${classnames}">$</${htmlTag}>${formatMoney(amount, currencyFormat)}`
    return formattedPrice
}